// Settings → Notifications → "When I'm not active on desktop, send to my phone" (#683). One dropdown, saved to the account:
// the room enforces it, so every device shares it. It is how long a desktop of mine may sit without input before my
// phone gets a push for a message I haven't read (shared/src/idlePush.ts).
import { useEffect, useState } from "react";
import { DEFAULT_IDLE_PUSH_MINUTES, IDLE_PUSH_CHOICES, idlePushMinutesOr, type UserSettings } from "@bloom/shared";
import { api } from "../api.ts";
import { SettingRow } from "./SettingsShell.tsx";

const HELP =
  "While you use Bloom on a computer, your phone waits. If you leave and haven't read a message after this long, the phone gets it. Right away: the phone always gets it at once. Never: your phone gets nothing while a computer is open in front of you. Saved to your account.";

export function IdlePushSetting() {
  const [minutes, setMinutes] = useState<number | null>(null);
  useEffect(() => {
    let live = true;
    api<UserSettings>("/me/settings").then(
      (s) => live && setMinutes(idlePushMinutesOr(s.idlePushMinutes)),
      () => live && setMinutes(DEFAULT_IDLE_PUSH_MINUTES),
    );
    return () => {
      live = false;
    };
  }, []);
  const pick = (next: number) => {
    const before = minutes;
    setMinutes(next);
    void api("/me/settings", { method: "PUT", body: { idlePushMinutes: next } }).catch(() => setMinutes(before));
  };
  return (
    <SettingRow label="When I'm not active on desktop" wide help={HELP}>
      <label className="lp-site">
        <span>Send to my phone</span>
        <select className="input" aria-label="Send to my phone" value={minutes ?? DEFAULT_IDLE_PUSH_MINUTES} disabled={minutes === null} onChange={(e) => pick(Number(e.target.value))}>
          {IDLE_PUSH_CHOICES.map((c) => (
            <option key={c.minutes} value={c.minutes}>
              {c.label}
            </option>
          ))}
        </select>
      </label>
    </SettingRow>
  );
}
